<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">

            <x-form-group label="Nama Panggilan"
                :error="getError('nickname')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.nickname"
                    required />
            </x-form-group>

            <x-form-group label="Nama Lengkap"
                :error="getError('name')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.name"
                    required />
            </x-form-group>

            <x-form-group label="Tempat Lahir"
                :error="getError('birthplace')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.birthplace"
                    required />
            </x-form-group>

            <x-form-group label="Tanggal Lahir"
                :error="getError('birthdate')"
                :is-required="true">
                <input type="date"
                    class="form-control"
                    v-model="fields.birthdate"
                    required />
            </x-form-group>

            <x-form-group label="Jenis Kelamin"
                :error="getError('gender')"
                :is-required="true">
                <select v-model="fields.gender" class="form-control" required>
                    <option value="Laki-Laki">Laki-Laki</option>
                    <option value="Perempuan">Perempuan</option>
                </select>
            </x-form-group>

            <x-form-group label="No. Telpon"
                :error="getError('phone')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.phone"
                    required />
            </x-form-group>

            <x-form-group label="Alamat"
                :error="getError('address')"
                :is-required="true">
                <textarea class="form-control"
                    v-model="fields.address"
                    required />
            </x-form-group>

            <x-form-group label="Email"
                :error="getError('email')"
                :is-required="true">
                <input type="email"
                    class="form-control"
                    v-model="fields.email"
                    required />
            </x-form-group>

            <x-form-group label="Konfirmasi Email"
                :error="getError('email_confirmation')"
                :is-required="true"
                v-if="emailConfirmation">
                <input type="email"
                    class="form-control"
                    v-model="fields.email_confirmation"
                    required />
            </x-form-group>

            <x-form-group label="Mengetahui Gibeon Church Dari"
                :error="getError('reference')"
                :is-required="true">
                <select v-model="fields.reference" class="form-control" required>
                    <option value="Facebook">Facebook</option>
                    <option value="Teman">Teman</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Lainnya">Lainnya</option>
                </select>
            </x-form-group>

            <x-form-group label="Status"
                :error="getError('status')"
                :is-required="true">
                <select v-model="fields.status" class="form-control" required>
                    <option value="Mahasiswa">Mahasiswa</option>
                    <option value="Lainnya">Lainnya</option>
                    <option value="Siswa">Siswa</option>
                    <option value="Bekerja">Bekerja</option>
                </select>
            </x-form-group>

            <x-form-group label="Bersedia Digembalakan"
                :error="getError('agree_to_be_nurtured')"
                :is-required="true">
                <x-checkbox-wrapper label="Bersedia">
                    <input type="checkbox"
                        v-model="fields.agree_to_be_nurtured" />
                </x-checkbox-wrapper>
            </x-form-group>

        </fieldset>
    </form>
</template>

<script>
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import FormErrorMixin from '../../mixins/FormErrorMixin'

export default {
    components: {
        XFormGroup,
        XFilterBox,
        XCheckboxWrapper,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        }
    },
    data() {
        return {
            fields: {
                nickname: null,
                name: null,
                birthplace: null,
                birthdate: null,
                gender: 'Laki-Laki',
                phone: null,
                address: null,
                email: null,
                email_confirmation: null,
                reference: 'Facebook',
                status: 'Mahasiswa',
                agree_to_be_nurtured: true,
            },
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('submit', this.fields)
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        emailConfirmation: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
}
</script>